import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { getKey } from "./api";
import KeyGate from "./KeyGate.jsx";
import JobsList from "./JobsList.jsx";
import JobDetail from "./JobDetail.jsx";

export default function OperatorApp() {
  const [unlocked, setUnlocked] = useState(Boolean(getKey()));

  if (!unlocked) return (
    <>
      <KeyGate onUnlock={() => setUnlocked(true)} />
      <Toaster theme="dark" position="top-center" richColors />
    </>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<JobsList onLock={() => setUnlocked(false)} />} />
        <Route path="/job/:id" element={<JobDetail />} />
        <Route path="*" element={<JobsList onLock={() => setUnlocked(false)} />} />
      </Routes>
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}
